module.exports = __webpack_public_path__ + "img/cost-icon__alberca_familiar.5e20f860.svg";